export default __webpack_public_path__ + "static/media/IMG_4467.2de9cf0e.jpeg";